import React from "react";
import { Switch, Route, Router, useLocation } from "react-router-dom";
import { QueryClientProvider } from "react-query";
import { MuiThemeProvider, StylesProvider, createTheme, } from "@material-ui/core/styles";
import "fontsource-roboto";
import { SnackbarProvider } from "notistack";
import { Notifier, notify } from "frontend/src/features/notifications";
import { history } from "frontend/src/lib/history";
import { routes } from "frontend/src/pages/routes/index";
import { queryClient } from "frontend/src/domain/query-client";
import "frontend/src/processes";
import { Redirect } from "react-router";
import { paths } from "./pages/paths/index";
import i18next from "i18next";
import { locales } from "./domain/localization/i18n";
import { ThemeModeContext, } from "frontend/src/shared/theme-mode";
var getInitialThemeMode = function () {
    var savedMode = window.localStorage.getItem("theme-mode");
    return savedMode === "dark" ? "dark" : "light";
};
var Routes = function () {
    useVerifyEmailNotification();
    return (React.createElement(Switch, null,
        routes.map(function (_a) {
            var Component = _a.Component, path = _a.path;
            return (React.createElement(Route, { path: path, key: path, exact: true, component: Component }));
        }),
        React.createElement(Route, { path: "*" },
            React.createElement(Redirect, { to: paths.login() }))));
};
var useVerifyEmailNotification = function () {
    var query = new URLSearchParams(useLocation().search);
    var verified = query.get("verified");
    React.useEffect(function () {
        if (verified === "1") {
            notify({
                variant: "success",
                message: i18next.t("notifications.emailVerified", {
                    ns: locales.namespaces.shared,
                }),
            });
        }
    }, [verified]);
};
function App() {
    var _a = React.useState(getInitialThemeMode), mode = _a[0], setMode = _a[1];
    var theme = React.useMemo(function () {
        return createTheme({
            palette: {
                type: mode,
            },
            overrides: {
                MuiTableCell: {
                    root: {
                        borderBottom: mode === "dark"
                            ? "1px solid rgba(255, 255, 255, 0.12)"
                            : "1px solid rgba(224, 224, 224, 1)",
                    },
                },
            },
        });
    }, [mode]);
    var themeMode = React.useMemo(function () { return ({
        mode: mode,
        toggleMode: function () {
            setMode(function (currentMode) {
                var nextMode = currentMode === "light" ? "dark" : "light";
                window.localStorage.setItem("theme-mode", nextMode);
                return nextMode;
            });
        },
    }); }, [mode]);
    return (React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(StylesProvider, { injectFirst: true },
            React.createElement(MuiThemeProvider, { theme: theme },
                React.createElement(ThemeModeContext.Provider, { value: themeMode },
                    React.createElement(SnackbarProvider, { maxSnack: 3 },
                        React.createElement(Router, { history: history },
                            React.createElement(Routes, null)),
                        React.createElement(Notifier, null)))))));
}
export default App;
